'use strict';

angular.module('theme').config(function ($translateProvider) {
	$translateProvider.translations('sv', {
		'ORDER': {
			'BREADCRUMB': {
				'CART': 'Välj meny & personer',
				'DETAILS': 'Leveransuppgifter',
				'START_WEEK': 'Sammanfattning',
				'PAY': 'Betalning'
			},
			'CART': {
				'TITLE': 'Upptäck fördelarna med våra kockförberedda matkassar!',
				'INFO': {
					'FIRST':'I stället för att bara leverera recept och råvaror, ger vi dig vardagsmenyer där alla tidskrävande moment som såser, grytbaser och andra smaksättare har förberetts av professionella kockar - alltid utan onödiga tillsatser.',
					'SECOND': 'För att du lättare ska kunna äta riktigt vällagade middagar även till vardags.'
				},
				'AMOUNT': 'Att betala',
				'CHOOSE': 'Välj matkasse här',
				'TOTAL': 'Totalt att betala',
				'TESTWEEK': 'Jag önskar endast en testvecka där ingen ytterligare leverans kommer ske per automatik',
				'SUPPLEMENTS': {
					'TITLE': 'Extra huvudråvara',
					'INFO': 'Vad är extra huvudråvara?',
					'TEXT': 'Behöver ni extra mycket protein? I så fall kan du välja att köpa till extra av veckans huvudråvaror. Det innebär att du får två portioner extra av fågel, fisk och kött.'
				},
				'SHOW_CODES': 'Har du ett presentkort eller en kampanjkod, klicka här.',
				'GIFTCARD': {
					'TITLE': 'Presentkort',
					'INPUT': 'Fyll i din presentkortskod'
				},
				'DISCOUNT': {
					'TITLE': 'Kampanjkod',
					'INFO': 'Kampanjkod? Klicka här',
					'INPUT': 'Fyll i din kampanjkod',
					'SELECTION': 'Välj din premie'
				},
				'ACTIVATE': 'Aktivera',
				'NEXT': 'Gå vidare'
			},
			'LOGIN': {
				'CREATE': {
					'TITLE': 'Ange din e-postadress:',
					'OR': 'eller',
					'FACEBOOK': 'Logga in med Facebook',
					'ERROR': {
						'DUPLICATE': 'Mejladressen finns redan registrerad hos oss, vänligen logga in som befintlig kund.',
						'SIGNUP': 'Det gick inte att skapa ett konto.'
					},
					'BUTTON': 'Gå vidare'
				},
				'EMAIL': {
					'LABEL': 'E-postadress',
					'INPUT': 'Ange din e-postadress'
				},
				'PASSWORD': {
					'LABEL': 'Lösenord',
					'INPUT': 'Ange ditt lösenord'
				}
			},
			'DUPLICATE': {
				'TITLE': 'Hej igen!',
				'INFO': {
					'FIRST': 'Vad kul att du tittar in igen. Du är redan registrerad kund hos oss.',
					'SECOND': 'Klicka på länken nedan och logga in på "Mina sidor" för att beställa.'
				},
				'CANCEL': 'Avbryt',
				'MYPAGE': 'Gå till Mina sidor'
			},
			'SSN': {
				'TITLE': 'Ange ditt personnummer:',
				'INFO': 'För att underlätta hämtar vi din adress från folkbokföringen',
				'INPUT': 'Ditt personnummer (ÅÅMMDD-NNNN)',
				'SEARCH': 'Hämta adressuppgifter',
				'CANCEL': 'Tillbaka',
			},
			'BILLING': {
				'TITLE': 'Vi hittade dessa uppgifter',
				'INFO': {
					'FIRST': 'Är det här du men vill ha leveransen till en annan adress?',
					'SECOND': 'Det fixar vi.'
				},
				'NO_DELIVERY': {
					'FIRST': 'Tyvärr kan vi inte leverera till',
					'SECOND': 'men du kanske har en annan adress dit vi kan leverera?'
				},
				'FIRSTNAME': 'Förnamn',
				'LASTNAME': 'Efternamn',
				'STREET': 'Gatuadress',
				'ZIPCODE': 'Postnummer',
				'CITY': 'Postort',
				'SSN': 'Personnummer',
				'SEARCH': 'Tillbaka',
				'CONFIRM': 'Gå vidare',
				'CHANGE': 'Ange annan leveransadress'
			},
			'SHIPPING': {
				'TITLE': 'Annan leveransadress',
				'STREET': 'Gatuadress',
				'ZIPCODE': 'Postnummer',
				'CITY': 'Postort',
				'ERROR': {
					'FIRST': 'Vi kan tyvärr ej leverera',
					'SECOND': 'till det angivna postnummret'
				},
				'CANCEL': 'Tillbaka',
				'CONFIRM': 'Använd som leveransadress'
			},
			'DETAILS': {
				'TITLE': 'Detaljer',
				'PHONE': {
					'LABEL': 'Ange ditt mobilnummer*',
					'INPUT': 'Mobilnumret behövs för att chauffören ska kunna avisera dina leveranser med ett sms'
				},
				'CODE': {
					'LABEL': 'Eventuell portkod',
					'INPUT': 'Ange portkod'
				},
				'FLOOR': {
					'LABEL': 'Eventuell våning',
					'INPUT': 'Ange våning'
				},
				'ADDITIONAL': {
					'LABEL': 'Annat som kan vara viktigt vid leverans (max 100 tecken)',
					'INPUT': 'Ange ev. övrig leveransinformation'
				},
				'CANCEL': 'Tillbaka',
				'SAVE': 'Gå vidare'
			},
			'SUMMARY': {
				'TERMS': {
					'TITLE': 'Allmänna villkor',
					'CANCEL': 'Avbryt',
					'ACCEPT': 'Godkänn villkoren'
				},
				'AMOUNT': 'Att betala',
				'SUPPLEMENTS': 'Extra huvudråvara',
				'CAMPAIGN': 'Kampanjkod',
				'DISCOUNT': 'Rabatt',
				'GIFTCARD': 'Presentkort eller kampanjkod? Klicka här',
				'SHIPPING': 'Leverans till:',
				'DELIVERY': 'Första leverans:',
				'PAYMETHOD': 'Betalsätt:',
				'CANCEL': 'Tillbaka',
				'CHANGE': 'Ändra'
			},
			'DELIVERY': {
				'TITLE': 'Startvecka',
				'INFO': 'Vi har inga bindningstider och du väljer själv om du vill ha leverans varje eller varannan vecka. Du kan även boka av enstaka veckor. Alla ändringar gör du på Min sida.',
				'DELIVERYDAY': 'Leverans',
				'CANCEL': 'Avbryt',
				'CONFIRM': 'Välj betalsätt'
			},
			'NO_DELIVERY': {
				'TITLE': 'Kan ej leverera till ditt postnummer',
				'INFO': 'Vi kan för närvarande inte leverera till ditt postnummer',
				'RETRY': 'Försök med annat personummer?'
			},
			'PAYMENT': {
				'TITLE': 'Betalsätt',
				'CARD_CREDIT': {
					'TITLE': 'Kreditbetalning via kort'
				},
				'CARD': {
					'TITLE': 'Direktbetalning via kort',
					'SELECT': 'Direktbetalning via kort',
					'COST': 'MasterCard, Visa, Amex, Diners. Avgift 0 kr.',
					'INFO': 'Du registrerar ditt kort hos oss och måndagen innan nästa leverans debiteras kortet för den kommande leveransveckan. Matkomfort använder',
					'PAYEX': 'Swedbank Pay.',
					'TEXT': 'Swedbank Pay krypterar all känslig kortdata så att ingen obehörig får tillgång till uppgifterna. Vid köp fyller du i kortnummer, giltighetstid och CVC-kod hos Swedbank Pay. Du kan också komma att behöva verifiera ditt kortköp hos din kortutgivare med Verified by VISA eller MasterCard SecureCode.',
					'BUTTON': 'Betala med kort'
				},
				'EMAIL': {
					'TITLE': 'Faktura via e-post',
					'SELECT': 'Faktura varannan vecka',
					'COST': 'Via e-post. Avgift 10kr.',
					'INFO': 'Du kan betala med faktura och välja att få fakturan skickad till dig via e-post (OBS! Detta är inte e-faktura). Faktureringsavgift: 10 kr. Fakturor skickas varannan måndag, avseende dina beställningar under perioden. Vid betalning med kredit genomförs en anmärkningskontroll.',
					'BUTTON': 'Betala med E-postfaktura'
				},
				'INVOICE': {
					'TITLE': 'Pappersfaktura',
					'SELECT': 'Faktura varannan vecka',
					'COST': 'Via post. Avgift 25 kr.',
					'INFO': 'Du kan betala med faktura och välja att få en pappersfaktura skickad hem till dig. Faktureringsavgift: 25 kr. Fakturor skickas varannan måndag, avseende dina beställningar under perioden. Vid betalning med kredit genomförs en anmärkningskontroll.',
					'BUTTON': 'Faktura'
				},
				'TERMS': {
					'FIRST': 'Jag har läst och godkänner',
					'SECOND': 'Matkomforts allmänna villkor'
				},
				'FINISH': 'Slutför beställning'
			},
			'PAYMENT_FAILED': {
				'TITLE': 'Betalning misslyckades',
				'INFO': 'Din betalning gick inte igenom, var god försök igen.',
				'RETRY': 'Försök igen?'
			},
			'PAYMENT_NOT_AVAILABLE': {
				'TITLE': 'Betalning misslyckades',
				'INFO': 'Du kan ej betala med faktura, men du har fortfarande alternativet att betala med kort',
				'CONFIRM': 'Betala med kort'
			},
			'RECEIPT': {
				'TITLE': 'Tack {{firstName}} för din beställning!',
				'INFO': 'Du kommer strax att få en orderbekräftelse skickad till {{email}}. Redan nu kan du gå till Min sida för mer information och för att hantera ditt abonnemang.',
				'BUTTON': 'Gå till Min sida'
			}
		},
		'MYPAGE': {
			'TERMS': {
				'ACCEPT': 'Jag godkänner matkomforts allmänna villkor.',
				'SAVE': 'Godkänn'
			},
			'GIFTCARD': {
				'INFO': 'När du klickar på Genomför bekräftar du köpet och du debiteras {{amount}} kr på nästa ordinarie faktura/kortdragning',
				'AMOUNT': 'Belopp',
				'MESSAGE': {
					'LABEL': 'Meddelande',
					'INPUT': 'Skriv gärna en hälsning till den som ska få presentkortet'
				},
				'ORDER': 'Beställ',
				'CONFIRM': 'Genomför',
				'CANCEL': 'Tillbaka',
				'SENT': 'Tack för din beställning av presentkort!'
			},
			'INVITE': {
				'FIRSTNAME': 'Väns förnamn',
				'LASTNAME': 'Väns efternamn',
				'EMAIL': 'Väns e-postadress',
				'SEND': 'Skicka',
				'SENT': 'Du har nu bjudit in din vän!'
			},
			'MENU': {
				'DELIVERY': 'Leverans',
				'MONDAY': 'Måndag',
				'TUESDAY': 'Tisdag',
				'WEDNESDAY': 'Onsdag',
				'THURSDAY': 'Torsdag',
				'FISH': 'Veckans fisk',
				'BIRD': 'Veckans fågel',
				'FANTASY': 'Veckans fantasi',
				'PDF': 'Ladda ner din meny som pdf.',
				'COMMENT': 'Skriv en kommentar',
				'SAVE': 'Spara betyg',
				'COMPLETED': 'Du har redan betygsatt denna meny',
				'RATING': 'Mitt betyg, 1-5',
				'RATING_INFO': 'Klicka i stjänorna för att betygsätta rätten.',
				'RATING_SUCCESS': 'Tack för dina betyg!',
				'NOT_EDITABLE': 'Det går inte att betygsätta denna meny',
				'NO_DELIVERY': 'Ingen leverans v.{{week}}',
				'RATE': 'Betygsätt meny',
				'RATE_SAVED': 'Betygsättningen är nu sparad',
				'NEXT_DELIVERY': {
					'INFO': 'Nästa leverans publiceras torsdag em.',
					'DELIVERY': 'Nästa leverans'
				},
				'CHOOSE': 'Välj meny',
				'CHANGE': 'Byt meny',
				'ORDER': 'Se menyer och beställ',
				'NOT_CHANGEABLE': 'Det går inte att ändra denna meny',
			},
			'OVERVIEW': {
				'PLAN': {
					'TITLE': 'Ändring av leveransplan',
					'INFO': {
						'FIRST': 'Är du säker på att du vill genomföra ändringarna?',
						'SECOND': 'Alla manuella ändringar du gjort i leveransplanen kommer att försvinna.'
					},
					'MENU': 'Välj meny',
					'WEEK': '{{odd ? \'Ojämna\' : \'Jämna\'}} veckor',
					'NO_DELIVERY': 'Ingen leverans',
					'CHOOSE': 'Välj meny',
					'EDIT': 'Ändra',
					'CHANGE': 'Byt meny',
					'REMOVE': 'Ta bort {{odd ? \'Ojämna\' : \'Jämna\'}} veckor',
					'SAVE': 'Spara',
					'CANCEL': 'Avbryt',
					'CONFIRM': 'Genomför',
					'SUPPLEMENTS': 'extra huvudråvaror',
					'SERVINGS_SAVED': 'Antal personer är nu sparat',
					'SUPPLEMENTS_SAVED': 'Extra huvudråvaror är nu sparat',
					'PRODUCT_SAVED': 'Produkt är nu sparad'
				},
				'ORDER': {
					'NO_DELIVERY': 'Ingen leverans',
					'CHANGED': 'Manuellt ändrad. Frångår ordinarie abonnemang.',
					'RESUME': 'Återgå',
					'ORDER': 'Beställ',
					'REMOVE': 'Avstå',
					'EDIT': 'Ändra',
					'CHANGE': 'Byt meny',
					'PLAN': 'Återgå till grundabonnemang',
					'SUPPLEMENTS': 'extra huvudråvaror',
					'DELIVERY_DAY': 'Leverans',
					'SAVED': 'Order sparad'
				},
				'ORDER_LAST_ITEM_MODAL': {
					'INFO': 'Du kan inte avstå eller ta bort alla leveranser här. Vill du göra ett längre uppehåll så behöver du pausa eller avsluta ditt abonnemang.',
					'PAUSE': 'Gå till pausa/avsluta abonnemang',
					'CANCEL': 'Återgå'
				},
				'MENU': {
					'CHANGE_MODAL_TITLE': 'Välj din matkasse',
					'CHOOSE': 'Välj meny',
					'CHANGE': 'Byt meny',
					'CHANGE_TO': 'Bekräfta',
					'KEEP': 'Fortsätt med'
				},
				'DELIVERY_DAY': {
					'TITLE': 'Leveransdag',
					'INFO': 'Här väljer du önskad leveransdag.',
					'SAVED': 'Leveransdag sparad',
					'METHOD': {
						'0': 'Hemleverans Söndag',
						'1': 'Hemleverans Måndag',
						'2': 'Utdelningsdag på fredag',
						'10': 'Hämta på ICA Stop Täby',
						'11': 'Hämta hos Matkomfort',
						'13': 'Hämta på Gulf Biskopskvarn',
						'14': 'Hämta på OKQ8 Skvaltan Nacka',
						'15': 'Hämta på OKQ8 Brommaplan',
						'16': 'Hämta på OKQ8 Haninge',
						'20': 'ICA Stop fredag',
						'21': 'Tyresö fredag',
						'SPECIAL': 'Hemleverans Söndag/Måndag',
					},
					'LABEL': 'Leveransdag/-plats'
				},
				'CHOOSE_MENU_BUTTON': {
					'LABEL': 'Meny',
					'CHANGE': 'Byt Meny'
				}
			},
			'BONUS': {
				'POINTS': 'poäng',
				'ORDER': 'Välj',
				'MODAL': {
					'TITLE': 'Premieval bekräftelse',
					'MESSAGE': 'Jag beställer {{bonus}} för {{points}} poäng.',
					'CONFIRM': 'Godkänn',
					'CANCEL': 'Avbryt'
				},
				'ORDERED': 'Premien är nu beställd'
			},
			'ACCOUNT': {
				'DETAILS': 'Uppgifter',
				'BILLING': 'Betalsätt',
				'PAUSE': 'Pausa/Avsluta',
				'QUIT': 'Avsluta'
			},
			'DETAILS': {
				'ACCOUNT': {
					'TITLE': 'Uppgifter',
					'EMAIL': {
						'LABEL': 'E-post:',
						'INPUT': 'E-post som du använder för att logga in med'
					},
					'EMAIL_NEWSLETTER': {
						'LABEL': 'Extra e-post:',
						'INPUT': '(För kopia på mail som vi skickar.)'
					},
					'EMAIL_BILLING': {
						'LABEL': 'Alternativ e-post för faktura:',
						'INPUT': 'Vill du få fakturan till en annan e-post?'
					},
					'FIRSTNAME': 'Förnamn:',
					'LASTNAME': 'Efternamn:',
					'SSN': 'Personnummer:',
					'CUSTOMER_NUMBER': 'Kundnummer:',
					'SAVE': 'Spara uppgifter',
					'SAVE_SUCCESS': 'Uppgifter sparat'
				},
				'PASSWORD': {
					'TITLE': 'Byt lösenord',
					'OLD_PASSWORD': {
						'LABEL': 'Gammalt lösenord:',
						'INPUT': 'Ange ditt gamla lösenord'
					},
					'NEW_PASSWORD': {
						'LABEL': 'Nytt lösenord:',
						'INPUT': 'Ange ditt nya lösenord'
					},
					'SAVE': 'Spara nytt lösenord',
					'SAVE_SUCCESS': 'Nytt lösenord sparat'
				},
				'ADDRESSES': {
					'TITLE': 'Leveransuppgifter',
					'HAS_SAME_ADDRESS': 'Fakturaadressen är samma som Leveransadressen',
					'BILLING': 'Fakturaadress',
					'SHIPPING': 'Leveransadress',
					'SHIPPING_ALERT': {
						'TITLE': 'Att tänka på!',
						'INFO': 'Vill du ha leverans till nya adressen redan på söndag? Meddela <a href="/kundtjanst/">kundtjänst</a> så chauffören åker rätt.'
					},
					'STREET': {
						'LABEL': 'Gatuadress:',
						'INPUT': 'Ange gatuadress'
					},
					'ZIPCODE': {
						'LABEL': 'Postnummer:',
						'INPUT': 'Ange postnummer'
					},
					'CITY': {
						'LABEL': 'Postort:',
						'INPUT': 'Ange ort'
					},
					'SAVE': 'Spara adresser',
					'SAVE_SUCCESS': 'Adresser sparade',
					'ERROR': {
						'FIRST': 'Vi kan tyvärr ej leverera',
						'SECOND': 'till det angivna postnummret'
					}
				},
				'DETAILS': {
					'TITLE': 'Detaljer',
					'MOBILE': {
						'LABEL': 'Mobilnummer:',
						'INPUT': 'Ange Mobilnummer',
						'INFO': '(Mobilnumret behövs för att chauffören ska kunna avisera dina leveranser med ett sms.)'
					},
					'PHONE': {
						'LABEL': 'Telefonnummer hem:',
						'INPUT': 'Ange Hemnummer',
						'INFO': '(Ange ett telefonnummer som vi kan nå dig på.)'
					},
					'CODE': {
						'LABEL': 'Portkod:',
						'INPUT': 'Ange portkod',
						'INFO': '(För att kunna komma in och lämna maten så behöver vi eventuell portkod.)'
					},
					'FLOOR': {
						'LABEL': 'Våning:',
						'INPUT': 'Ange våning'
					},
					'ADDITIONAL': {
						'LABEL': 'Leveransinformation:',
						'INPUT': 'Ange ev. övrig leveransinformation',
						'INFO': '(Information som kan hjälpa föraren, t.ex. om hen ska ställa maten vid garaget.)'
					},
					'TERMS_AND_CONDITIONS': 'Allmänna villkor',
					'SAVE': 'Spara ändringar',
					'SAVE_SUCCESS': 'Detaljer sparade'
				}
			},
			'BILLING': {
				'CURRENT': {
					'TITLE': 'Nuvarande betalsätt',
					'CARD': 'Kortbetalning',
					'VALID': 'Kort giltigt till',
					'EMAIL_INVOICE': 'E-postfaktura',
					'EMAIL': 'E-post',
					'INVOICE': 'Faktura',
					'STREET': 'Gatuadress',
					'ZIPCODE': 'Postnummer',
					'CITY': 'Postort'
				},
				'EMAIL_BILLING': {
					'TITLE': 'E-postfaktura',
					'INFO': 'Genom att uppge en e-postadress här så kan du få faktura/fakturaunderlag skickad till den adressen istället för din ordinarie e-postadress.',
					'LABEL': 'E-post',
					'INPUT': 'Om du vill få fakturan till annan e-postadress, fyll i adressen här',
					'INPUT_CARD': 'Om du vill få fakturaunderlaget till annan e-postadress, fyll i adressen här',
					'SAVE': 'Spara',
					'SAVE_SUCCESS': 'E-postfakturaaddress sparad'
				},
				'CHANGE': {
					'TITLE': 'Byt betalsätt',
					'CARD': {
						'TITLE': 'Kortbetalning',
						'INFO': 'Du registrerar ditt kort hos oss och måndagen innan nästa leverans debiteras kortet för den kommande leveransveckan. Matkomfort använder Swedbank Pay betalsystem.',
						'BUTTON': 'Betala med kort'
					},
					'EMAIL': {
						'TITLE': 'E-postfaktura',
						'INFO': 'Du kan betala med faktura och välja att få fakturan skickad till dig via e-post (OBS! Detta är inte e-faktura). Faktureringsavgift: 10 kr. Fakturor skickas varannan måndag, avseende dina beställningar under perioden.',
						'BUTTON': 'Betala med E-postfaktura'
					},
					'INVOICE': {
						'TITLE': 'Faktura',
						'INFO': 'Du kan betala med faktura och välja att få en pappersfaktura skickad hem till dig. Faktureringsavgift: 25 kr. Fakturor skickas varannan måndag, avseende dina beställningar under perioden.',
						'BUTTON': 'Faktura'
					},
					'PAYMETHOD': 'Ändra betalsätt',
					'INFO': 'Är du säker på att du vill ändra ditt betalsätt?',
					'CANCEL': 'Avbryt',
					'CONFIRM': 'Ändra'
				}
			},
			'PAUSE': {
				'TITLE': 'Pausa/avsluta abonnemang',
				'INFO': 'Du kan pausa/avsluta ditt abonnemang genom att välja slut och stardatum nedan',
				'PAUSED': 'Ditt abonnemang är pausat till {{startDate}}.',
				'PAUSED_NO_START': 'Ditt abonnemang är avslutat. Du kan när du vill beställa enstaka matkassar, lägg till önskad vecka under Mina Leveranser eller aktivera ditt abonnemang här igen.',
				'CANCELED': 'Ditt abonnemang är avslutat',
				'PAUSE': 'Gå vidare',
				'RESUME': 'Aktivera',
				'RESUME_SUCCESS': 'Ditt abonnemang är nu återupptaget',
				'CANCEL': 'Avbryt',
				'CONFIRM': 'Genomför',
				'CONFIRM_SUCCESS': 'Ditt abonnemang är nu återupptaget',
				'STOP_DATE': 'När vill du ha din sista leverans?',
				'START_DATE': 'Vet du redan nu när du vill återta ditt abonnemang? Välj datum och vecka.',
				'NO_DATES': 'Det finns tyvärr inga tillgängliga slutdatum för ditt valda startdatum',
				'CONFIRM_INFO': 'Vill du pausa ditt abonnemang tills vidare?',
				'CONFIRM_INFO_STOP_START': 'Vill du pausa ditt abonnemang med sista leverans {{stopDate}} {{stopWeek}} och med start {{startDate}} {{startWeek}}?',
				'CONFIRM_INFO_NO_STOP': 'Vill du pausa ditt abonnemang och återuppta {{startDate}} {{startWeek}}?',
				'CONFIRM_INFO_NO_START': 'Vill du pausa ditt abonnemang med sista leverans {{stopDate}} {{stopWeek}}?',
				'SAVE_SUCCESS': 'Paus sparad'
			},
			'QUIT': {
				'TITLE': 'Avsluta abonnemang',
				'INFO': 'Du kan avsluta ditt abonnemang genom att trycka på knappen nedan',
				'CANCELED': 'Ditt konto är avslutat',
				'BUTTON': 'Avsluta',
				'RESUME': 'Återuppta',
				'RESUME_SUCCESS': 'Ditt abonnemang är nu återupptaget',
				'DATE': 'När vill du ha din sista leverans?',
				'CANCEL': 'Avbryt',
				'CONFIRM': 'Genomför',
				'CONFIRM_INFO': 'Är du säker på att du vill avsluta ditt abonnemang hos Matkomfort med sista leverans {{quitDate}} {{quitWeek}}?',
				'CONFIRM_INFO_NO_STOP': 'Är du säker på att du vill avsluta ditt abonnemang hos Matkomfort?',
				'CONFIRM_SUCCESS': 'Ditt abonnemang är nu avslutat',
				'FORM': {
					'TITLE': 'Frågeformulär för uppsägning',
					'INFO': 'Vi har mottagit din uppsägning av Matkomfort och vill först framföra ett tack för förtroendet den tiden du varit kund hos oss. Vi skulle uppskatta om du tog dig tid att fylla i nedanstående frågeformulär. För oss är varje kunds synpunkter viktigt och det hjälper oss att bli ännu bättre.',
					'SENT': 'Tack för dina svar!',
					'SEND': 'Skicka',
					'OTHER_ANSWER': 'annan orsak, vänligen specificera',
					'FIRST_QUESTION': {
						'TITLE': '1. Hur länge har du varit kund hos Matkomfort?',
						'ANSWER': {
							'FIRST': 'Testkund',
							'SECOND': 'kund 4-12 veckor',
							'THIRD': 'kund 3 månader eller längre'
						}
					},
					'SECOND_QUESTION': {
						'TITLE': '2. Vilken är den största anledningen till att du valt att säga upp ditt abonnemang?',
						'ANSWER': {
							'FIRST': 'Barnen äter inte tillräckligt av maten',
							'SECOND': 'För dyrt i förhållande till vad mitt hushåll vill lägga på vardagsmat',
							'THIRD': 'Jag vill själv bestämma vad jag skall äta i min vardag',
							'FOURTH': 'Har någon form av allergi som gör att jag inte kan äta alla rätter',
							'FIFTH': 'Har svårt att vara hemma och ta emot min leverans på söndagar'
						}
					},
					'THIRD_QUESTION': {
						'TITLE': '3. Vad har varit bäst med konceptet?',
						'ANSWER': {
							'FIRST': 'Tidsbesparande och tid över för annat',
							'SECOND': 'Trygg och säker leverans',
							'THIRD': 'Enkelt att tillaga, varierad och bra mat med bra råvaror',
							'FOURTH': 'Barnvänliga menyer och där både de vuxna och barnen i hushållet gillar maten'
						}
					},
					'FOURTH_QUESTION': {
						'TITLE': '4. Kommer du att testa Matkomfort igen?',
						'ANSWER': {
							'FIRST': 'Ja absolut men det passar oss inte just nu',
							'SECOND': 'Ja kanske',
							'THIRD': 'Inte troligt',
							'FOURTH': 'Nej'
						}
					},
					'FIFTH_QUESTION': {
						'TITLE': '5. Hur kommer du efter avslutat abonnemang hos Matkomfort lösa din vardagsmat?',
						'ANSWER': {
							'FIRST': 'Välja en annan leverantör',
							'SECOND': 'Börja planera och handla och tillaga själva igen',
							'THIRD': 'Inte bestämt mig'
						}
					},
					'SIXTH_QUESTION': {
						'TITLE': '6. Övriga kommentarer du vill ge till oss som står bakom företaget Matkomfort'
					}
				}
			},
			'SPECIAL_ORDER': {
				'MODAL': {
					'TITLE': 'Beställning av {{product.title}}',
					'INFO': 'Du har valt att beställa vår {{product.title}}, {{number}} personer {{price}} kronor. Leverans 22 december mellan 17-22. Debitering kommer att ske enligt ordinarie betalsätt. Du kan fram till torsdagen den 14 december justera antal eller boka av din låda via din abonnemangsöversikt.',
					'CONFIRM': 'Genomför beställning',
					'CANCEL': 'Avbryt'
				},
				'SUCCESS': 'Beställning av {{product.title}} genomförd. Tack för din beställning!'
			},
			'SUPPLEMENT_ORDER': {
				'MODAL': {
					'TITLE': 'Tillägg av {{supplement.title}} vecka {{order.week}}',
					'INFO': 'Du har valt att göra ett engångstillägg av {{supplement.title}}. Tillägget levereras vecka {{order.week}} med ordinarie leverans. Debitering kommer att ske enligt ordinarie betalsätt med {{price}} kr. Du kan fram till kl. 10 måndagen innan leverans justera eller ta bort tillägg via din abonnemangsöversikt.',
					'CONFIRM': 'Bekräfta tillägget',
					'CANCEL': 'Avbryt tillägget'
				},
				'SUCCESS': 'Vi har lagt till {{supplement.title}} till din ordinarie leverans vecka {{order.week}}. Tack för din beställning!'
			}
		},
		'THEME': {
			'COOKIES': {
				'TITLE': 'Denna webbplats använder sig av cookies för att ge dig en trevlig användarupplevelse. Genom att använda sidan godkänner du också användandet av cookies enligt Matkomforts integritetspolicy.',
				'INFO': 'Vad är cookies?',
				'CLOSE': 'Jag godkänner'
			},
			'CAMPAIGN': {
				'LINK': 'Läs mer'
			},
			'FOODCOURT_MODAL': {
				'TITLE': 'DU BEVEGER DEG NÅ INN PÅ EN MATBLOGG SKREVET DELVIS PÅ NORSK OG OG DELVIS PÅ SVENSK...',
				'MESSAGE': 'Selvsagt bør du ta innholdet med en klype salt (tilsvarer omtrent ett kryddermål). Men siden kan kanskje være verdt et besøk allikevel? I så fall er du hjertelig velkommen!',
				'CLOSE': 'Okej'
			},
			'PAUSED_ACCOUNT': {
				'TITLE_DELIVERIES_LEFT': 'Ditt abonnemang är vilande, sista leverans {{stopDate}}, återupptas {{startDate}}.',
				'TITLE_DELIVERIES_LEFT_NO_START': 'Ditt abonnemang är vilande, sista leverans {{stopDate}}.',
				'TITLE_RESUME': 'Ditt abonnemang är vilande och återupptas {{startDate}}.',
				'TITLE_RESUME_NO_START': 'Ditt abonnemang är vilande.',
				'RESUME': 'Aktivera'
			},
			'QUIT_ACCOUNT': {
				'TITLE_DELIVERIES_LEFT': 'Ditt abonnemang är avslutat och sista leveransdagen för ditt abonnemang är {{stopDate}}.',
				'TITLE_RESUME': 'Ditt abonnemang är avslutat.',
				'RESUME': 'Återuppta'
			},
			'PRODUCT': {
				'ORDER': 'Beställ',
				'PORTIONS': 'personer',
				'TITLE': 'Personer',
				'PRICE': 'Pris',
				'PRICES': 'Se priser'
			},
			'PORTION_BUTTON': {
				'LABEL': 'Antal personer',
				'PORTIONS': 'personer',
				'TITLE': 'Personer',
				'PRICE': 'Pris'
			},
			'SUPPLEMENTS_BUTTON': {
				'LABEL': 'Extra huvudråvara',
				'TITLE': 'Extra huvudråvara',
				'AMOUNT': 'Antal',
				'PRICE': 'Pris'
			},
			'TEST_WEEK_BUTTON': {
				'TEST': 'Test',
				'SUBSCRIPTION': 'Abonnemang'
			},
			'STICKER': {
				'ORDER': 'Beställ klistermärken',
				'ORDERED': 'Klistermärken är nu beställda'
			},
			'RESET_PASSWORD': {
				'TITLE': 'Återställ lösenord',
				'ERROR': 'Någonting gick fel. Vänligen försök igen.',
				'EMAIL_ERROR': 'Vänligen ange en gilltig e-postadress',
				'SENT': 'Ditt nya lösenord har skickats till {{email}}'
			},
			'ZIPCODE_CHECK': {
				'TITLE': 'Testa ditt postnummer',
				'INVALID': 'Ogiltigt postnummer',
				'CONFIRMED': 'Grattis, du kan få Matkomfort hem till dörren!',
				'UNCERTAIN': 'Vi kanske kan leverera till dig! Skicka din adress till kundtjänst eller ring oss, så kollar vi upp om du kan få leverans.',
				'NO_DELIVERY': 'Tyvärr, vi kan i dagsläget ej leverera till dig.',
				'ORDER': 'Beställ',
				'TEST': 'Testa'
			},
			'GIFTCARD_CHECK': {
				'TITLE': 'Testa din väns postnummer',
				'INVALID': 'Ogiltigt postnummer',
				'CONFIRMED': 'Grattis, din vän kan få Matkomfort hem till dörren!',
				'UNCERTAIN': 'Vi kanske kan leverera till det angivna postnummret, kontakta kundtjänst för mera information.',
				'NO_DELIVERY': 'Tyvärr, vi kan i dagsläget ej leverera till det angivna postnummret.',
				'ORDER': 'Beställ',
				'TEST': 'Testa'
			}
		}
	});
});
